import {
  Slider as MuiSlider,
  type SliderProps as MuiSliderProps,
} from '@mui/base'
import { forwardRef } from 'react'

import './Slider.scss'

const Slider = forwardRef<HTMLElement, MuiSliderProps>(function Slider(
  props,
  ref
) {
  return (
    <MuiSlider
      ref={ref}
      slotProps={{
        rail: { className: 'a-Slider__rail' },
        root: { className: 'a-Slider' },
        thumb: { className: 'a-Slider__thumb' },
        track: { className: 'a-Slider__track' },
      }}
      {...props}
    />
  )
})

export default Slider
